/* eslint-disable */
import Vue from 'vue';

let observer = null;

Vue.directive('in-viewport', {
    inserted(el, binding) {
        const offset = binding.value && binding.value.offset ? `-${binding.value.offset}` : 0;
        const delay = binding.value && binding.value.delay ? binding.value.delay : 0;
        const callback = binding.value && binding.value.callback ? binding.value.callback : null;

        observer = new IntersectionObserver(
            entries => handleIntersect(el, entries, delay, callback),
            {
                rootMargin: `0px 0px ${offset}px 0px`,
                threshold: [0, 0.05, 0.01],
            },
        );

        observer.observe(el);
    },
    unbind(el) {
        if (observer) {
            observer.unobserve(el);
        }
    },
});

function handleIntersect(el, entries, delay, callback) {
    if (entries[0].intersectionRatio > 0) {
        setTimeout(() => {
            el.classList.add('isInViewport');
            if (callback) {
                callback();
            }
            if (observer) {
                observer.unobserve(el);
            }
        }, delay);
    }
}
